// import Vue from "vue"
// window.Vue = require('vue');
// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
// import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vue from 'vue'
// import Vuetify from "vuetify/lib"
// window.Vuetify = require('vuetify');
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Translation provided by Vuetify (javascript)
import it from 'vuetify/lib/locale/it'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
	lang: {
		locales: { it },
		current: 'it',
	},
  theme: {
    dark: false,
	  themes: {
	    light: {
	      primary: "#6D94CD",
	      secondary: "#e6901c",
	      accent: "#8c9eff",
		    info: '#2196F3',
		    success: '#8bba40',
		    warning: '#FFC107',
	      error: "#b71c1c",
	    },
	    dark: {
	      primary: "#e6901c",
		    secondary: "#fff",
		    warning: '#FFC107',
		    error: "#b71c1c",
	    },
	  },
  },
})

export default vuetify